import React from "react";
import { useCloseTicket } from "../hooks/useCloseTicket.js";
import { useAuth } from "../context/AuthContext";
import { addInterventionsTicket } from "../lib/ticket";
import moment from "moment";
import { FaLock } from "react-icons/fa";
import { getDisplayTitle } from "../utils/titleformat";

const CloseTicketModal = ({ ticket, onClose, onSubmitSuccess, onError }) => {
  const { closeTicket, loading: closeTicketLoading } = useCloseTicket();
  const { userInfo } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    try {
      const now = moment().format("YYYY-MM-DD HH:mm:ss");
      const intervention = {
        utilisateur: 1013,
        description: `DEMANDE DE CLOTURE par ${userInfo?.userName}: ${form.descriptionTicketAdd.value}`,
        date_debut: now,
        duree: 1,
      };
      const success = await addInterventionsTicket(ticket.idTicket, intervention);
      if (success) {
        onClose();
        onSubmitSuccess();
      } else {
        onError();
      }
    } catch (e) {
      console.error("Erreur :", e);
      onError();
    }
  };

  return (
    <>
      <div className="modal-backdrop fade show" />
      <div className="modal fade show d-block modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
        <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
          <div className="modal-content shadow-lg">
            <form onSubmit={handleSubmit}>
              <div className="modal-header bg-light border-bottom">
                <div>
                  <h5 className="modal-title font-weight-bold">
                    <FaLock className="me-2 text-warning" />
                    Demande de clôture
                  </h5>
                  <small className="text-muted">{getDisplayTitle(ticket?.titre)}</small>
                </div>
                <button type="button" className="btn-close" onClick={onClose} aria-label="Fermer" />
              </div>

              <div className="modal-body">
                <div className="form-group mb-0">
                  <label className="font-weight-semibold">
                    Message <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    name="descriptionTicketAdd"
                    rows={5}
                    placeholder="Décrivez la raison de la clôture..."
                    required
                  />
                </div>
              </div>

              <div className="modal-footer bg-light border-top">
                <button type="button" className="btn btn-secondary" onClick={onClose}>
                  Annuler
                </button>
                <button
                  type="submit"
                  className="btn btn-warning text-white"
                  disabled={closeTicketLoading}
                  data-testid="close-ticket-button-modal"
                >
                  {closeTicketLoading ? "Envoi..." : "Demander la clôture"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default CloseTicketModal;
